const actionPrefix = 'CHARGER_TELEMETRY';

export const SET_EVENTS_ITEMS_ACTION = `${actionPrefix}_SET_EVENTS_ITEMS`;
export const APPEND_EVENTS_ITEM_ACTION = `${actionPrefix}_APPEND_EVENTS_ITEM`;
export const PREPEND_EVENTS_ITEM_ACTION = `${actionPrefix}_PREPEND_EVENTS_ITEM`;

export const SET_CHARGER_SNAPSHOT = `${actionPrefix}_SET_CHARGER_SNAPSHOT`;
export const SET_SNAPSHOT_LOADING = `${actionPrefix}_SET_SNAPSHOT_LOADING`;
export const SET_CHARGER_METRICS = `${actionPrefix}_SET_CHARGER_METRICS`;
export const SET_CHARGER_METRICS_BY_AGGREGATION = `${actionPrefix}_SET_CHARGER_METRICS_BY_AGGREGATION`;
export const SET_CHARGER_ID = `${actionPrefix}_SET_CHARGER_ID`;
export const RESET_CHARGER_TM_STATE = `${actionPrefix}_RESET_CHARGER_TM_STATE`;
export const MERGE_REAL_TIME_METRICS = `${actionPrefix}_MERGE_REAL_TIME_METRICS`;

export const AGGREGATION_INTERVAL_15S = '15s';
export const AGGREGATION_INTERVAL_1MIN = '1min';
export const AGGREGATION_INTERVAL_10MIN = '10min';
export const AGGREGATION_INTERVAL_1H = '1hour';
export const AGGREGATION_INTERVAL_1D = '1day';
export const AGGREGATION_INTERVAL_1W = '1week';

export const AGGREGATION_INTERVALS = {
  [AGGREGATION_INTERVAL_1MIN]: {
    label: '1 minute',
    milliseconds: 60 * 1000,
  },
  [AGGREGATION_INTERVAL_10MIN]: {
    label: '10 minutes',
    milliseconds: 600 * 1000,
  },
  [AGGREGATION_INTERVAL_1H]: {
    label: '1 hour',
    milliseconds: 3600 * 1000,
  },
  [AGGREGATION_INTERVAL_1D]: {
    label: '1 day',
    milliseconds: 3600 * 24 * 1000,
  },
  [AGGREGATION_INTERVAL_1W]: {
    label: '1 week',
    milliseconds: 3600 * 24 * 7 * 1000,
  },
};

export const GAP_BETWEEN_CONSOLIDATED_ECHARTS = 320;
export const CONSOLIDATED_ECHARTS_HEIGHT = 200;
export const CONSOLIDATED_ECHARTS_INITIAL_INSIDE_TOP_GAP = 70;

export const AGGREGATIONS_FOR_GRAPH = ['avg', 'min', 'max'];
